export default "__VITE_PUBLIC_ASSET__621af3de__"